import { Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import { FaArrowRight } from "react-icons/fa6";

import { Button } from "@/components/ui/button";
import { useLocale } from "@/contexts/IntlContext";
import { useAuthStore } from "@/lib/stores/authStore";
import goodHeart from "@/assets/new-logo.svg";

function NotFound() {
  const { locale } = useLocale();
  const { user } = useAuthStore();
  const isRtl = locale === "ar";
  
  const userAudience = user?.audience;
  const contentPath = userAudience === "CHILD" ? "/children/exercises" : "/adults/exercises";

  return (
    <div className="px-6 py-16 flex items-center justify-center w-full max-w-xl ">
      <div className="flex flex-col items-center gap-5 text-center">
        <div className="rounded-full p-4">
          <img src={goodHeart} alt="HAMD Logo" className="h-13 w-13" />
        </div>

        <div className="flex items-center gap-2 text-small uppercase tracking-[0.14em] text-dark-gray">
          <span className="font-semibold text-dark">404</span>
          <span
            className="h-1 w-1 rounded-full bg-black/35"
            aria-hidden="true"
          />
          <FormattedMessage id="notFound.kicker" />
        </div>

        <h1 className="text-h1 font-heading text-dark">
          <FormattedMessage id="notFound.title" />
        </h1>
        <p className="text-body text-dark-gray">
          <FormattedMessage id="notFound.description" />
        </p>

        <Link to={contentPath} className="w-full ">
          <Button className="w-full gap-2">
            {isRtl ? (
              <>
                <FaArrowRight className="h-4 w-4" />
                <FormattedMessage id="notFound.cta" />
              </>
            ) : (
              <>
                <FormattedMessage id="notFound.cta" />
                <FaArrowRight className="h-4 w-4" />
              </>
            )}
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
